import T from '../../services/language';
import {Header} from "../../components/Header";
import Step from "../../components/Step";
import {Container, ContainerView, ContainerViewFooter} from "../../components/Container";
import {
    AddOn,
    AddOnItem,
    AddOnItems,
    AddOnTitle,
    Booking,
    BookingInfoTitle,
    BookingInfoValue,
    CloseModalIcon,
    EyeIcon,
    ImagePdf,
    PdfIcon,
    Question,
    QuestionnaireImage,
    QuestionnaireImages,
    QuestionPlaceholderLoading,
    Service,
    Title,
    ViewImageModal,
    ViewImageModalClose,
    ViewImageModalImage
} from "./style";
import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {
    CacheScheduleService,
    fileUrlExacter,
    getAnswers,
    getFileView, getHtmlText,
    getProductAndService,
    getQuestions,
    postBooking
} from "../../services/app";
import {useApp} from "../../contexts/app";
import {message, Modal} from "antd";
import {NextButton, PackageButton, Packages} from "../../components/Button";
import {ChooseTimeItem} from "../Booking/style";
import {
    ModalContent,
    ModalContentBody,
    ModalContentFooter,
    ModalContentFooterCancel,
    ModalContentFooterSubmit,
    ModalContentHead,
    ModalContentHeadDesc,
    ModalContentHeadTitle
} from "../Campaign/style";
import moment from "moment";
import Environment from "../../environment";
import {PlaceholderLoadingContainer, TextPlaceholder} from "../../components/Loading/placeholder";
import {Image} from "../../components/Image";
import useSessionCompleted from "../../hooks/completed";
import produce from "immer";
import {DotLoading} from "../../components/DotLoading";

export default function Confirm(props: any) {
    const [productService, setProductService] = useState<any>({});
    const [answers, setAnswers] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [answerLoading, setAnswerLoading] = useState({});
    const [ready, setReady] = useState(false);
    let {
        groupSlug,
        shareUrlKey,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        quantity,
        packageIndex,
        postalCode, locationType, productServiceTemplateId
    }: any = useParams();
    const navigate = useNavigate();
    const {
        getCurrentBooking,
        customer,
        setCurrentBooking,
        getAllBooking,
        getLocalProductService,
        clientCode,
        getLocalAddon, refreshData,
    } = useApp();
    packageIndex = parseInt(packageIndex);
    quantity = parseInt(quantity);
    const booking = getCurrentBooking(packageIndex);
    const bookings = getAllBooking();
    const addon = getLocalAddon(customerId) || [];
    const placeholderLoadingRef = useRef<any>();
    const [loading, setLoading] = useState(false);
    const sessionCompleted = useSessionCompleted()

    useEffect(() => {
        if (!booking) {
            navigate(`/${groupSlug}/${shareUrlKey}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/booking/${locationType}/0/${postalCode || ""}`);
        } else {
            loadData();
        }
    }, [packageIndex]);

    const loadData = async () => {
        setReady(false)
        placeholderLoadingRef.current.show();
        onScrollPackage();
        await Promise.all([
            getQuestions(campaignId).then((resultRemoteQuestions) => {
                setQuestions([
                    ...(resultRemoteQuestions?.data?.data?.templateItems || []).sort((a, b) => {
                        return a.index > b.index ? 1 : (a.index < b.index ? -1 : 0)
                    }),
                    ...(resultRemoteQuestions?.data?.data?.items || []).sort((a, b) => {
                        return a.index > b.index ? 1 : (a.index < b.index ? -1 : 0)
                    })
                ])
            }),
            getAnswers(customerId, packageIndex + 1).then((result) => {
                setAnswers((result?.data?.data?.items || []).filter(item => item.packageIndex === (packageIndex + 1)))
            }),
            getProductAndService(campaignId, productServiceId).then((result) => {
                setProductService(result?.data?.data || {})
            }),
        ]);
        placeholderLoadingRef.current.hide();
        setReady(true)
    }

    const onSubmit = async () => {
        setLoading(true);
        booking.postalCode = booking.postalCode || undefined;
        booking.unitNo = booking.unitNo || undefined;
        booking.code = customer.code || undefined;
        const data = {
            "customerId": booking.customerId,
            "campaignServiceId": productServiceType === 'service' ? productServiceId : undefined,
            "campaignProductId": productServiceType === 'product' ? productServiceId : undefined,
            "campaignId": booking.campaignId,
            "quantity": quantity,
            "code": customer.code || undefined,
            "addOn": addon,
            packages: bookings.map(item => {
                return {
                    "scheduleId": item.scheduleId,
                    "scheduleVersion": item?.scheduleVersion || item?.schedule?.scheduleVersion || undefined,
                    "bookingDate": item.bookingDate,
                    "startTime": item.startTime,
                    "endTime": item?.schedule?.value?.toTimeText || item?.endTime,
                    "endDate": item?.schedule?.endDate,
                    "postalCode": item.postalCode,
                    "unitNo": item.unitNo,
                    "address": item.address,
                    "slotId": item?.schedule?.slotId || undefined,
                    "slotDuration": (!item?.schedule?.slotId ? item?.schedule?.slotDuration : undefined),
                }
            })
        };
        const result = await postBooking(data);
        if (result.status === 200) {
            // set done
            sessionCompleted.set();
            // create new param
            const query = new URLSearchParams({
                bookingRef: result?.data?.data?.bookingRef || '',
                bookingId: result?.data?.data?.id || ''
            }).toString();
            // Save bookingId to local to access
            window.localStorage.setItem("bookingId", result?.data?.data?.id || '');
            // add new query to navigate
            navigate(`/${groupSlug}/${shareUrlKey}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/thankyou?${query}`, {replace: true});
            message.success(T("You've booked Successfully!"));
        } else {
            // reload campaign & service data
            await refreshData(["campaign", "service"]);

            message.error(result?.data?.message || "");
            const errorIndex = (result?.data?.data?.packageIndex || 1) - 1;
            goBookingPackageIndex(errorIndex);
        }
        setLoading(false);
    }

    const onNext = async () => {
        if (isEndPackage) {
            setModal(true)
        } else {
            setCurrentBooking({...booking, confirmed: true}, packageIndex);
            goPackageIndex(packageIndex + 1)
        }
    }

    const goPackageIndex = (index) => {
        navigate(`/${groupSlug}/${shareUrlKey}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/confirm/${locationType}/${index}/${postalCode || ""}`);
    }
    const goBookingPackageIndex = (index) => {
        // Clear cache schedule
        CacheScheduleService.clear().then(() => console.log("Clear schedule local cache!"));
        // Back to booking
        navigate(`/${groupSlug}/${shareUrlKey}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/booking/${locationType}/${index}/${postalCode || ""}`);
    }

    const onScrollPackage = () => {
        document?.querySelector('.packages .active')?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "end"
        });
    }

    const onFileClick = async (fileUrl: string, canPreview: boolean) => {
        const originUrl = fileUrlExacter(fileUrl).originUrl;
        setAnswerLoading(produce(draft => {
            draft[fileUrl] = true;
        }));
        const result = await getFileView(originUrl);
        if (result?.status === 200) {
            let linkView = result?.data?.data;
            if (canPreview) {
                setModalImage(linkView);
            } else {
                window.open(linkView, '_blank');
            }
        } else {
            message.error(result?.data?.message || T("Cannot access file"));
        }
        setAnswerLoading(produce(draft => {
            draft[fileUrl] = false;
        }));
    }

    const isEndPackage = ((packageIndex + 1) === quantity);
    const isOnlineMode = locationType === 'online';
    const isOnsiteMode = locationType === 'onsite';
    const isMyLocationMode = locationType === 'my-location';

    return (
        <Container>
            <Header title={T("Booking Details")} back={false} right={(
                <Step ignores={isOnlineMode ? [T("Location")] : []} current={isOnlineMode ? 3 : 4} dotStyle/>)}/>

            <PlaceholderLoadingContainer ref={placeholderLoadingRef}>
                <ContainerView style={(quantity > 1) ? {} : {paddingTop: 1}}>
                    {
                        quantity > 1 ? (
                            <Packages className={"packages"}>
                                {
                                    [...Array(parseInt(quantity)).keys()].map((value, index) => {
                                        const hasConfirm = !!getCurrentBooking(index)?.confirmed;
                                        const service = getLocalProductService(productServiceId);
                                        return (
                                            <PackageButton
                                                onClick={() => {
                                                    if (hasConfirm) {
                                                        goPackageIndex(index);
                                                        onScrollPackage();
                                                    }
                                                }}
                                                className={`${hasConfirm ? 'has-value' : ''} ${index.toString() === packageIndex.toString() ? 'active' : ""}`}
                                                key={index.toString()}><span>{service?.name} ({value + 1})</span></PackageButton>
                                        )
                                    })
                                }
                            </Packages>
                        ) : null
                    }

                    <Title>{T('Booking Info')}</Title>
                    <Booking>
                        <ul>
                            <li>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.37511 1.78V1C8.37511 0.795 8.20511 0.625 8.00011 0.625C7.79511 0.625 7.62511 0.795 7.62511 1V1.75H4.37511V1C4.37511 0.795 4.20511 0.625 4.00011 0.625C3.79511 0.625 3.62511 0.795 3.62511 1V1.78C2.27511 1.905 1.62011 2.71 1.52011 3.905C1.51011 4.05 1.63011 4.17 1.77011 4.17H10.2301C10.3751 4.17 10.4951 4.045 10.4801 3.905C10.3801 2.71 9.72511 1.905 8.37511 1.78Z"
                                        fill="#727C8A"/>
                                    <path
                                        d="M10 4.92188H2C1.725 4.92188 1.5 5.14687 1.5 5.42188V8.50187C1.5 10.0019 2.25 11.0019 4 11.0019H8C9.75 11.0019 10.5 10.0019 10.5 8.50187V5.42188C10.5 5.14687 10.275 4.92188 10 4.92188ZM4.605 9.10687C4.555 9.15187 4.5 9.18687 4.44 9.21187C4.38 9.23688 4.315 9.25187 4.25 9.25187C4.185 9.25187 4.12 9.23688 4.06 9.21187C4 9.18687 3.945 9.15187 3.895 9.10687C3.805 9.01187 3.75 8.88188 3.75 8.75187C3.75 8.62187 3.805 8.49188 3.895 8.39688C3.945 8.35188 4 8.31687 4.06 8.29187C4.18 8.24187 4.32 8.24187 4.44 8.29187C4.5 8.31687 4.555 8.35188 4.605 8.39688C4.695 8.49188 4.75 8.62187 4.75 8.75187C4.75 8.88188 4.695 9.01187 4.605 9.10687ZM4.71 7.19187C4.685 7.25187 4.65 7.30687 4.605 7.35687C4.555 7.40188 4.5 7.43687 4.44 7.46187C4.38 7.48688 4.315 7.50187 4.25 7.50187C4.185 7.50187 4.12 7.48688 4.06 7.46187C4 7.43687 3.945 7.40188 3.895 7.35687C3.85 7.30687 3.815 7.25187 3.79 7.19187C3.765 7.13188 3.75 7.06687 3.75 7.00187C3.75 6.93687 3.765 6.87187 3.79 6.81187C3.815 6.75187 3.85 6.69687 3.895 6.64687C3.945 6.60187 4 6.56687 4.06 6.54187C4.18 6.49187 4.32 6.49187 4.44 6.54187C4.5 6.56687 4.555 6.60187 4.605 6.64687C4.65 6.69687 4.685 6.75187 4.71 6.81187C4.735 6.87187 4.75 6.93687 4.75 7.00187C4.75 7.06687 4.735 7.13188 4.71 7.19187ZM6.355 7.35687C6.305 7.40188 6.25 7.43687 6.19 7.46187C6.13 7.48688 6.065 7.50187 6 7.50187C5.935 7.50187 5.87 7.48688 5.81 7.46187C5.75 7.43687 5.695 7.40188 5.645 7.35687C5.555 7.26187 5.5 7.13188 5.5 7.00187C5.5 6.87187 5.555 6.74187 5.645 6.64687C5.695 6.60187 5.75 6.56687 5.81 6.54187C5.93 6.48687 6.07 6.48687 6.19 6.54187C6.25 6.56687 6.305 6.60187 6.355 6.64687C6.445 6.74187 6.5 6.87187 6.5 7.00187C6.5 7.13188 6.445 7.26187 6.355 7.35687Z"
                                        fill="#727C8A"/>
                                </svg>
                                <BookingInfoTitle><b>{T('Date:')}</b></BookingInfoTitle>
                                <BookingInfoValue><span>{moment(booking?.bookingDate, Environment.dateFormat).format('DD ddd - MMMM, YYYY')}</span></BookingInfoValue>
                            </li>
                            <li>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6 1C3.245 1 1 3.245 1 6C1 8.755 3.245 11 6 11C8.755 11 11 8.755 11 6C11 3.245 8.755 1 6 1ZM8.175 7.785C8.105 7.905 7.98 7.97 7.85 7.97C7.785 7.97 7.72 7.955 7.66 7.915L6.11 6.99C5.725 6.76 5.44 6.255 5.44 5.81V3.76C5.44 3.555 5.61 3.385 5.815 3.385C6.02 3.385 6.19 3.555 6.19 3.76V5.81C6.19 5.99 6.34 6.255 6.495 6.345L8.045 7.27C8.225 7.375 8.285 7.605 8.175 7.785Z"
                                        fill="#727C8A"/>
                                </svg>
                                <BookingInfoTitle><b>{T('Time:')}</b></BookingInfoTitle>
                                <BookingInfoValue><span>{booking?.schedule?.value?.fromTimeText2} - {booking?.schedule?.value?.toTimeText2}</span></BookingInfoValue>
                            </li>
                            {
                                productServiceType === 'product' ? (
                                    <li>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7 1.46V5.615C7 6.125 6.585 6.54 6.075 6.54H1.5C1.225 6.54 1 6.315 1 6.04V2.845C1 1.825 1.825 1 2.845 1H6.535C6.795 1 7 1.205 7 1.46Z"
                                                fill="#727C8A"/>
                                            <path
                                                d="M10.75 7.75C10.89 7.75 11 7.86 11 8V8.5C11 9.33 10.33 10 9.5 10C9.5 9.175 8.825 8.5 8 8.5C7.175 8.5 6.5 9.175 6.5 10H5.5C5.5 9.175 4.825 8.5 4 8.5C3.175 8.5 2.5 9.175 2.5 10C1.67 10 1 9.33 1 8.5V7.5C1 7.225 1.225 7 1.5 7H6.25C6.94 7 7.5 6.44 7.5 5.75V3C7.5 2.725 7.725 2.5 8 2.5H8.42C8.78 2.5 9.11 2.695 9.29 3.005L9.61 3.565C9.655 3.645 9.595 3.75 9.5 3.75C8.81 3.75 8.25 4.31 8.25 5V6.5C8.25 7.19 8.81 7.75 9.5 7.75H10.75Z"
                                                fill="#727C8A"/>
                                            <path
                                                d="M4 11C4.55228 11 5 10.5523 5 10C5 9.44772 4.55228 9 4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11Z"
                                                fill="#727C8A"/>
                                            <path
                                                d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z"
                                                fill="#727C8A"/>
                                            <path
                                                d="M11 6.265V7H9.5C9.225 7 9 6.775 9 6.5V5C9 4.725 9.225 4.5 9.5 4.5H10.145L10.87 5.77C10.955 5.92 11 6.09 11 6.265Z"
                                                fill="#727C8A"/>
                                        </svg>
                                        <BookingInfoTitle><b>{T('Delivery Method:')}</b></BookingInfoTitle>
                                        <BookingInfoValue><span>{booking?.modeOfDelivery === "delivery-only" ? "Delivery" : ""}</span></BookingInfoValue>

                                    </li>
                                ) : null
                            }
                            {
                                !isOnlineMode ? (
                                    <>
                                        <li>
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg"></svg>
                                            <div style={{display: "inline-flex", flex: 1}}>
                                                <BookingInfoTitle><b>{T('Address:')}</b></BookingInfoTitle>
                                                <BookingInfoValue><span>{booking?.address}</span></BookingInfoValue>
                                            </div>
                                        </li>
                                        <li>
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg"></svg>
                                            <BookingInfoTitle><b>{T('Unit No.:')}</b></BookingInfoTitle>
                                            <BookingInfoValue><span>{booking?.unitNo}</span></BookingInfoValue>
                                        </li>
                                        <li>
                                            <svg width="10" height="12" viewBox="0 0 10 12" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M5.00024 0C2.60387 0 0.654297 1.94958 0.654297 4.34592C0.654297 7.31986 4.54349 11.6858 4.70908 11.8702C4.86461 12.0434 5.13616 12.0431 5.29141 11.8702C5.45699 11.6858 9.34619 7.31986 9.34619 4.34592C9.34614 1.94958 7.39659 0 5.00024 0ZM5.00024 6.53248C3.79457 6.53248 2.81371 5.55159 2.81371 4.34592C2.81371 3.14025 3.79459 2.15939 5.00024 2.15939C6.20589 2.15939 7.18675 3.14027 7.18675 4.34595C7.18675 5.55162 6.20589 6.53248 5.00024 6.53248Z"
                                                    fill="#727C8A"/>
                                            </svg>
                                            <BookingInfoTitle><b>{T('Postal code:')}</b></BookingInfoTitle>
                                            <BookingInfoValue><span>{booking?.postalCode}</span></BookingInfoValue>
                                        </li>
                                    </>
                                ) : null
                            }

                        </ul>
                    </Booking>
                    <Title>{T('Service Info')}</Title>
                    <Service>
                        <div className={'image'}>
                            <Image style={{height: 96}}
                                   src={productService?.thumbnailUrl || "/assets/images/default_service.png"}/>
                        </div>
                        <div className={'info'}>
                            <TextPlaceholder lines={[1]} itemStyle={{width: 100, marginLeft: 0, height: 18}}
                                             style={{margin: 0, marginTop: 12}}>
                                <h3>{productService?.name}</h3>
                            </TextPlaceholder>
                            <TextPlaceholder lines={[1, 2, 3]} style={{width: "90%"}} itemStyle={{height: 12}}>
                                <div className={"info-value"}
                                     dangerouslySetInnerHTML={{__html: getHtmlText(productService?.descriptions || "")}}></div>
                            </TextPlaceholder>
                        </div>
                    </Service>
                    {
                        addon?.length ? (
                            <AddOn>
                                <AddOnTitle>{T('Add-on')}</AddOnTitle>
                                <AddOnItems>
                                    {addon.map((item, index) => {
                                        return (
                                            <AddOnItem key={index.toString()}>
                                                {item}
                                            </AddOnItem>
                                        )
                                    })}
                                </AddOnItems>
                            </AddOn>
                        ) : null
                    }

                    <Title>{T('Questionnaire')}</Title>
                    <QuestionPlaceholderLoading/>
                    <QuestionPlaceholderLoading/>
                    <QuestionPlaceholderLoading/>

                    {
                        ready ? (
                            <>
                                {questions.filter(x => x?.showToCustomer).map((item, index) => {
                                    const items = answers.find(x => x.questionId === item.id);
                                    let answerText = items?.answer;
                                    if (item?.type === 'date') {
                                        const date = moment(items?.answer || "", Environment.dateFormat, true);
                                        if (date.isValid()) {
                                            answerText = date.format(Environment.dateFormatView);
                                        }
                                    }

                                    return (
                                        <Question key={index.toString()}>
                                            <div className={'index'}>{index + 1}</div>
                                            <div className={'content'}>
                                                <h3>{item.content}</h3>
                                                {
                                                    items?.options?.length && !answerText ? (<ul>
                                                            {items.options?.map((x, i) => {
                                                                return (<li key={i.toString()}><p>{x.value}</p></li>)
                                                            })}
                                                        </ul>
                                                    ) : null
                                                }
                                                {
                                                    answerText ? (<p>{answerText || ""}</p>) : null
                                                }
                                                <QuestionnaireImages className="hide-scroll">
                                                    {(items?.imageUrls || []).map((v, i) => {
                                                        const isPdf = v.toString().toLowerCase().includes('.pdf');
                                                        const fileName = v.toString().split('/').pop().split('.')[0];

                                                        return (
                                                            <QuestionnaireImage key={i.toString()}>
                                                                {isPdf ? (<>
                                                                    <ImagePdf>
                                                                        <PdfIcon/>
                                                                        <div className={'filename'}>
                                                                            <span>{window.decodeURIComponent(fileName || "")}</span>
                                                                            <span>.pdf</span>
                                                                        </div>
                                                                    </ImagePdf>
                                                                </>) : (
                                                                    <img src={v}/>
                                                                )}
                                                                {
                                                                    !!answerLoading[v] ? (
                                                                        <span className={"open"} style={{
                                                                            width: 25,
                                                                            height: 25,
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            display: 'flex'
                                                                        }}>
                                                                            <DotLoading size={3} space={2}/>
                                                                        </span>
                                                                    ) : (
                                                                        <EyeIcon className={"open"}
                                                                                 onClick={() => onFileClick(v, !isPdf)}/>
                                                                    )
                                                                }
                                                            </QuestionnaireImage>
                                                        )
                                                    })}
                                                </QuestionnaireImages>
                                                <ViewImageModal style={{display: modalImage ? 'flex' : 'none'}}>
                                                    <ViewImageModalImage>
                                                        <img src={modalImage} alt={""}/>
                                                    </ViewImageModalImage>
                                                    <ViewImageModalClose onClick={() => setModalImage("")}>
                                                        <CloseModalIcon/>
                                                    </ViewImageModalClose>
                                                </ViewImageModal>
                                            </div>
                                        </Question>
                                    )
                                })}
                                {
                                    !questions?.length ? (
                                        <ChooseTimeItem style={{
                                            width: '100%',
                                            marginTop: 12,
                                            fontSize: 14
                                        }}>{T('No Questions')}</ChooseTimeItem>
                                    ) : null
                                }
                            </>
                        ) : null
                    }

                    <ContainerViewFooter>
                        <NextButton disabled={!ready} onClick={() => {
                            onNext()
                        }}>
                            {quantity > 1 ? T("Submit booking ({index})", {index: (packageIndex + 1)}) : T("Submit booking")}
                        </NextButton>
                    </ContainerViewFooter>
                </ContainerView>
            </PlaceholderLoadingContainer>


            <Modal centered open={!!modal} width={340} modalRender={() => (
                <ModalContent>
                    <ModalContentHead style={{paddingTop: 16, minHeight: 48}}>
                        <ModalContentHeadTitle style={{fontSize: 24}}>{T('Are you sure?')}</ModalContentHeadTitle>
                    </ModalContentHead>
                    <ModalContentBody style={{minHeight: "inherit", height: "auto", marginTop: 16}}>
                        <ModalContentHeadDesc
                            style={{fontSize: 16}}>{T('Please check all the packages carefully before you proceed')}</ModalContentHeadDesc>
                    </ModalContentBody>
                    <ModalContentFooter style={{justifyContent: 'space-between', marginTop: 16}}>
                        <ModalContentFooterCancel disabled={loading} style={{width: 145}} onClick={() => {
                            setModal(false);
                        }}>{T("No")}</ModalContentFooterCancel>
                        <ModalContentFooterSubmit loading={loading} style={{width: 145}}
                                                  onClick={onSubmit}>{T('I’ve checked')}</ModalContentFooterSubmit>
                    </ModalContentFooter>
                </ModalContent>
            )}/>
        </Container>
    )
}
